import React from 'react';
import Dialog from '../../../../../../../../BaseComponents/Dialog/EDDialog';
import EDButton from '../../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import { ISumData } from '../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import EkonomiskAnalysSummeringList from './Components/EkonomiskAnalysSummeringList/EkonomiskAnalysSummeringList';
import EkonomiskAnalysSummeringToolbar from './Components/EkonomiskAnalysSummeringToolbar/EkonomiskAnalysSummeringToolbar';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import AvailableSumCategoriesQuery from './Queries/AvailableSumCategoriesQuery';
import EDAvenyProgress from '../../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

interface IProps {
  selectedSums: ISumData[];
  onUpdate: (sums: ISumData[]) => void;
  buttonGutter?: boolean;
  classes?: any;
}

interface IState {
  newSelectedSums: ISumData[];
  open: boolean;
}

const styles = (theme: Theme) => ({
  dialogPaper: {
    minWidth: '800px',
    [theme.breakpoints.down('lg')]: {
      minWidth: '200px',
    },
  },
  contentContainer: {
    marginTop: theme.spacing(2),
  },
});

/**
 * Test
 */
export class EkonomiskAnalysSummeringSelect extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      newSelectedSums: props.selectedSums,
      open: false,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.selectedSums !== this.props.selectedSums) {
      this.setState({
        newSelectedSums: this.props.selectedSums,
      });
    }
  }

  toggleOpen = () => {
    this.setState(prevState => ({
      open: !prevState.open,
      newSelectedSums: !prevState.open
        ? this.props.selectedSums
        : prevState.newSelectedSums,
    }));
  };

  toggleChoise = (selected: boolean, selectedSum: ISumData) => {
    const newSums = selected
      ? this.state.newSelectedSums.filter(sum => sum.Namn !== selectedSum.Namn)
      : [...this.state.newSelectedSums, selectedSum];
    this.setState({
      newSelectedSums: newSums,
    });
  };

  update = () => {
    this.props.onUpdate(this.state.newSelectedSums);
    this.toggleOpen();
  };

  clearSelected = () => {
    this.setState({
      newSelectedSums: [],
    });
  };

  render() {
    return (
      <>
        <EDButton
          label="Välj summering"
          icon={<EDIcon iconType="sigma" color="inherit" marginRight={1} />}
          onClick={this.toggleOpen}
          flat
          primary
          padding={1}
          labelNotUpperCase
          lowEmphasis
          margin={this.props.buttonGutter ? 1 : undefined}
        />
        <AvailableSumCategoriesQuery>
          {({ loading, error, availableCategories }) => (
            <Dialog
              open={this.state.open}
              title={'Välj summering'}
              onClose={this.toggleOpen}
              headerTools={
                <EkonomiskAnalysSummeringToolbar
                  onClearSelected={this.clearSelected}
                />
              }
              footerActions={[
                { onClick: this.toggleOpen, label: 'Avbryt' },
                { onClick: this.update, label: 'Använd' },
              ]}
              classes={{ paper: this.props.classes.dialogPaper }}
            >
              <div className={this.props.classes.contentContainer}>
                {loading && <EDAvenyProgress />}
                {!loading && error && error.message}
                {!loading &&
                  availableCategories == null &&
                  'Kunde inte hämta summeringsbegrepp'}
                {!loading && availableCategories != null && !error && (
                  <EkonomiskAnalysSummeringList
                    availableCategories={availableCategories}
                    selectedSums={this.state.newSelectedSums}
                    toggleSelectedSum={this.toggleChoise}
                  />
                )}
              </div>
            </Dialog>
          )}
        </AvailableSumCategoriesQuery>
      </>
    );
  }
}

export default withStyles(EkonomiskAnalysSummeringSelect, styles);
